import Link from "next/link";
import NoResult from "../no-results";

export default function UserFavouritesTable({ games }: Readonly<{games: [{id: string, title: string}] | null}>){
    return (
        <div className="grid grid-cols-1 gap-2 text-lg border border-black p-3">
            <p className="text-xl font-bold">Giochi preferiti</p>
            {(games === null || games.length < 1) && <NoResult />}
            { games != null && games.length > 0 &&
                <ul className="max-h-[330px] overflow-y-scroll">
                    {games.map((game, index) => (
                        <li key={game.id}>
                            <Link
                                className="my-2 flex w-full items-center justify-between gap-4 px-2"
                                key={game.id}
                                href={`/games/${game.id}`}
                            >
                                <i
                                    className={`text-3xl ${index % 2 == 0 ? 'bi-dice-5-fill' : 'bi-dice-5'}`}
                                ></i>
                                <p className="w-full truncate text-start">
                                    {game.title}
                                </p>
                                <div className="flex justify-end">
                                    <i className="bi-arrow-up-right-circle text-3xl text-[#E9A242]" />
                                </div>
                            </Link>
                        </li>
                    ))}
                </ul>
            }
        </div>
    )
}